import React from 'react'
import styled, { keyframes } from 'styled-components'

// A compact loading indicator: the "points rise from the ground" motion of the
// full loading animation, stripped to four staggered dots. Sits in the action
// bar next to the zoom controls so it is obvious when an action triggers a load.

const VB_W = 60
const VB_H = 22
const GROUND_Y = 18
const DOT_XS = [8, 21, 34, 47]
// How high each dot rises, as a translate from the ground. Varied so the row
// reads as data points, not a progress bar.
const RISES = [-11, -7, -13, -9]
const LOOP_SECONDS = 1.6
const STAGGER = 0.14

const rise = keyframes`
  0%   { transform: translateY(0); }
  40%  { transform: translateY(var(--rise)); }
  80%  { transform: translateY(0); }
  100% { transform: translateY(0); }
`

const Svg = styled.svg`
  width: 1.75rem;
  height: 0.65rem;
  overflow: visible;
`

const Dot = styled.circle<{ $delay: number }>`
  fill: rgba(255, 255, 255, 0.92);
  transform-box: fill-box;
  transform-origin: center;
  animation: ${rise} ${LOOP_SECONDS}s cubic-bezier(0.22, 1, 0.36, 1) infinite;
  animation-delay: ${({ $delay }) => $delay}s;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const TimeSeriesLoadingDots: React.FC = () => (
  <Svg viewBox={`0 0 ${VB_W} ${VB_H}`} aria-hidden='true'>
    {DOT_XS.map((x, i) => (
      <Dot
        key={x}
        cx={x}
        cy={GROUND_Y}
        r={2.5}
        style={{ '--rise': `${RISES[i]}px` } as React.CSSProperties}
        $delay={i * STAGGER}
      />
    ))}
  </Svg>
)
